import axios from 'axios';
import { uniqueArray } from '../helpers/unique-array';

export interface Solution {
  name: string;
  image: string | null;
  gallery: string[][] | null;
}

export interface Country {
  name: string;
  continent: string;
  tier: string;
}

export interface Industry {
  name: string;
  category: string;
  risk: string;
}

export interface Licence {
  name: string;
  category: string;
  risk: string;
  country: string;
}

export interface StaticData {
  solutions: Solution[];
  countries: Country[];
  industries: Industry[];
  licenses: Licence[];
}

const staticDataURL = 'https://zotapay.com/wp-json/pricechecker/get';

export const getStaticData = async (): Promise<StaticData> => {
  const response = await axios.get(staticDataURL);
  const data = response.data;

  return {
    solutions: data.solutions,
    countries: data.countries,
    industries: uniqueArray(data.industries, 'name'),
    licenses: uniqueArray(data.licenses, 'name'),
  };
};